const concatClasses = (cssClasses, dedupe = false) => {
  if (dedupe) {
    cssClasses = Array.from(new Set(cssClasses));
  }
  return cssClasses.join(" ");
};
export {
  concatClasses
};
